<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col class="text-center" cols="12" md="6">
        <v-img :src="logo" alt="Logo" max-height="200" class="mb-4"></v-img>
        <h1 class="display-2 font-weight-bold mb-2">404</h1>
        <h2 class="headline font-weight-normal mb-2">Page Not Found</h2>
        <p class="subtitle-1 mb-5">
          Sorry, the page you are looking for does not exist. It may have been moved, or removed altogether. 
          Perhaps you can return back to the site's homepage and see if you can find what you are looking for.
        </p>
        <v-btn large color="primary" :to="{ name: 'home' }">Go to Home</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PageNotFound",
  data() {
    return {
      logo: require('@/assets/FactsLogoBg.png') // Ensure the path is correct
    };
  }
};
</script>

<style scoped>
</style>
  